import React from "react";
import NavbarDropdown from "./NavbarDropdown";
import {
  appRoutes,
  dashboardRoutes,
  eligibilityRoutes,
  preauthorizationRoutes,
} from "routes/siteMaps";
import { Dropdown } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useAppContext } from "providers/AppProvider";

const NavbarTopDropDownMenus = () => {
  const {
    config: { navbarCollapsed, showBurgerMenu },
    setConfig,
  } = useAppContext();

  const handleDropdownItemClick = () => {
    if (navbarCollapsed) {
      setConfig("navbarCollapsed", !navbarCollapsed);
    }
    if (showBurgerMenu) {
      setConfig("showBurgerMenu", !showBurgerMenu);
    }
  };

  const renderRoute = (route) => {
    if (route.children && route.children.length > 0) {
      return (
        <NavbarDropdown title={route.name}>
          <div style={{ position: "relative", zIndex: 1000 }}>
            {route.children.map((child) => (
              <Link
                key={child.name}
                to={child.to}
                className={`dropdown-item ${
                  child.active ? "link-600" : "text-500"
                }`}
                onClick={handleDropdownItemClick}
                style={{ position: "relative", zIndex: 1000 }}
              >
                {child.name}
              </Link>
            ))}
          </div>
        </NavbarDropdown>
      );
    } else {
      return (
        <Link
          to={route.to}
          className="nav-link"
          onClick={handleDropdownItemClick}
        >
          {route.name}
        </Link>
      );
    }
  };

  return (
    <>
      {renderRoute(dashboardRoutes.children[0])}
      {/* {eligibilityRoutes.children.map((route) => renderRoute(route))} */}
      {/* {preauthorizationRoutes?.children?.map(route => renderRoute(route))} */}
      {/* {appRoutes?.children?.map((route) => renderRoute(route))} */}
    </>
  );
};

export default NavbarTopDropDownMenus;
